import React from "react";
import { shape, string } from "prop-types";
import { Link } from "@quintype/components";
import { getLinkTarget } from "../../../arrow/utils/utils";

import "./conference-story-card.m.css";

const ConferenceStoryCard = ({ story, variant = "upcoming", showEventName, eventType = "", ...props }) => {
  const {
    headline,
    subheadline,
    "hero-image-s3-key": heroImageS3Key,
    "hero-image-metadata": heroImageMetadata,
    slug,
    cards = [],
    metadata = {},
  } = story;

  const eventDate = eventType === "sessions" ? metadata?.when : metadata?.duration || cards[0]?.["story-elements"]?.[0]?.metadata?.answer || "" ;
  const eventLocation = metadata?.where || cards[0]?.["story-elements"]?.[1]?.metadata?.answer || "";
  const backgroundImage = heroImageS3Key
    ? `https://images.assettype.com/${heroImageS3Key}`
    : "";
  const sessionForum = metadata['session-forum'];

  return (
    <Link
      href={`/${slug}`}
      styleName={`conference-story-card ${variant} ${eventType}`}
      aria-label={headline}
      target={getLinkTarget(`/${slug}`)}
      rel="noopener"
      {...props}
    >
      <div
        styleName="card-background"
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none"
        }}
      />

      <div styleName="card-content">
        <div styleName="event-info">
        {eventType === "sessions" && sessionForum && (
          <div styleName="session-forum">
            <p>{sessionForum}</p>
          </div>
        )}
        {showEventName && 
          <div styleName="event-name">
            <p>{headline}</p>
          </div>
        }

          <div styleName={`event-title`}>
            <p>{subheadline}</p>
          </div>
        </div>

        <div styleName="date-venue-section">
          <div styleName="date-venue-info">
            {eventDate && (
              <div styleName="event-date">
                <p>{eventDate.replace(/<[^>]*>/g, '').trim()}</p>
              </div>
            )}
            {eventLocation && (
              <div styleName="event-location">
                <p style={eventLocation.replace(/<[^>]*>/g, '').trim().toLowerCase() === 'online' ? { color: 'var(--text-black)' } : {}}>
                  {eventLocation.replace(/<[^>]*>/g, '').trim()}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

ConferenceStoryCard.propTypes = {
  story: shape({
    headline: string.isRequired,
    subheadline: string,
    "hero-image-s3-key": string,
    "hero-image-metadata": shape({}),
    slug: string.isRequired,
    attributes: shape({
      "event-date": string,
      "event-location": string
    })
  }).isRequired,
  variant: string
};

export default ConferenceStoryCard;
